module.exports = __webpack_public_path__ + "media/images/donation/how-to-use3-c282591326a77fd8376fb9c0b5a17789.jpg";